export const onUpdate = (table, id, starred) => ({
  type: 'UPDATE',
  table,
  id,
  starred
})
